import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "@/components/app/shell/page-header";
import { Button } from "@/components/ui/button";
import { useFacility } from "@/lib/facility/facility";
import { ArrowLeft } from "@/lib/icons";
import { orpc } from "@/lib/orpc";
import { guardRoute } from "@/lib/policy/route-guard";
import { VisitHistory } from "../-components/visit-history";

export const Route = createFileRoute(
  "/_authenticated/_visitors/visitors/departments/$departmentId",
)({
  beforeLoad: ({ context }) => guardRoute(context.me, "visitors"),
  component: VisitorDepartmentPage,
});

/** Everyone who came to one department: the history behind one row of the departments list. */
function VisitorDepartmentPage() {
  const { departmentId } = Route.useParams();
  const { facilityId } = useFacility();
  const departments = useQuery(
    orpc.visitors.departments.list.queryOptions({
      input: { facilityId, includeInactive: true },
    }),
  );
  const department = departments.data?.find((row) => row.id === departmentId);
  return (
    <div className="flex flex-col gap-5">
      <Button asChild variant="ghost" size="sm" className="self-start">
        <Link to="/visitors/departments">
          <ArrowLeft data-icon="inline-start" aria-hidden="true" />
          All departments
        </Link>
      </Button>
      <PageHeader
        title={department ? `Visits to ${department.name}` : "Visits to this department"}
        meta={department && !department.isActive ? "This department is archived." : undefined}
      />
      <VisitHistory
        source={{ kind: "list", filter: { facilityId, departmentId } }}
        emptyTitle="No visits to this department yet"
      />
    </div>
  );
}
